import script from "./RiaSans.vue?vue&type=script&setup=true&lang=js"
export * from "./RiaSans.vue?vue&type=script&setup=true&lang=js"

import "./RiaSans.vue?vue&type=style&index=0&id=b11e4c56&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b11e4c56"]])

export default __exports__